import { Box } from "@mui/material";
import Header from "../../components/Header";
import OnlineCard from "./dashboard_components/onlineCard";
import DaysRemaining from "./dashboard_components/daysRemaining";
import TiresiaLoad from "./dashboard_components/tiresiaLoad";
import AverageBandwitch from "./dashboard_components/averageBandwitch";
import GlobalAttack from "./dashboard_components/globalAttack";
import RatingGraph from "./dashboard_components/ratingGraph";
import OrionRatingGraph, { OrionRatingGraphSkeleton } from "./dashboard_components/orionRatingGraph";
import Highlights from "./dashboard_components/highlights";
import Grid from "@mui/material/Grid";
import GlobeH from "./dashboard_components/map";
import { useState, useEffect } from "react";
import API from "../../api/index";


const Dashboard = () => {
  const [, setVisibleGlobe] = useState(false)
  const [agent, setAgent] = useState(false)
  const [lecs, setLecs] = useState(false)
  const [agentLicence, setAgentLicence] = useState(false)
  const [ratingData, setRatingData] = useState(undefined)
  const [highlightsData, setHighlightsData] = useState(undefined)
  // Orion visibility decides which score widget the dashboard renders — the
  // legacy passive-vulnerabilities RatingGraph, or the richer OrionRatingGraph
  // (Network Security Score, same as the Network Overview "Security" tab).
  // null = not resolved yet, so nothing renders in its place until it is.
  const [orionVisible, setOrionVisible] = useState(null)

  useEffect(() => {
    const controller = new AbortController()
    const { signal } = controller

    API.getLicensesAgent(undefined, signal)
      .then((res) => {
        if (res.data.length > 0) {
          setAgent(true);
          setAgentLicence(res.data)
        }
      })
      .catch((err) => { if (err.name !== 'CanceledError') console.error('[Dashboard] failed to fetch agent licenses:', err) });

    API.getLecsAccount(undefined, signal)
      .then((res) => setLecs(res.data[0]))
      .catch((err) => { if (err.name !== 'CanceledError') console.error("[Dashboard] LECSACCOUNT error:", err) });

    API.getOrionVisibility()
      .then((res) => setOrionVisible(res?.data?.visibility === true))
      .catch(() => setOrionVisible(false));

    /*
    API.getHighlightsHome(signal)
      .then((res) => setHighlightsData(res.data))
      .catch((err) => { if (err.name !== 'CanceledError') { console.error("[Dashboard] HIGHLIGHTS error:", err); setHighlightsData(null) } });*/

    return () => controller.abort()
  }, []);

  // Legacy rating is only needed when Orion isn't active — skip the request
  // entirely once we know OrionRatingGraph will be rendered instead.
  useEffect(() => {
    if (orionVisible !== false) return;
    const controller = new AbortController()
    API.getRating(undefined, controller.signal)
      .then((res) => setRatingData(res.data))
      .catch((err) => { if (err.name !== 'CanceledError') { console.error("[Dashboard] RATING error:", err); setRatingData(null) } });
    return () => controller.abort()
  }, [orionVisible]);



  return (
    <Box m="20px">
      {/* HEADER */}
      <Box display="flex" justifyContent="space-between" alignItems="center">
        <Header title="DASHBOARD" subtitle="" />
      </Box>

      {/* GRID & CHARTS */}
      <Grid container spacing={2} sx={{ marginTop: 2 }}>

        {/* ROW 1 */}

        <Grid size={{ xs: 12, sm: 6, md: 3 }}><OnlineCard agent={agent} lecs={lecs} /></Grid>
        <Grid size={{ xs: 12, sm: 6, md: 3 }}><DaysRemaining agent={agent} agentLicence={agentLicence} lecs={lecs} /></Grid>
        <Grid size={{ xs: 12, sm: 6, md: 3 }}><TiresiaLoad agent={agent} agentLicence={agentLicence} lecs={lecs} /></Grid>
        <Grid size={{ xs: 12, sm: 6, md: 3 }}><AverageBandwitch agent={agent} lecs={lecs} /></Grid>

        {/* ROW 2 */}
        <Grid size={8}>
          <GlobalAttack agent={agent} lecs={lecs} />
        </Grid >
        <Grid size={4}>
          <GlobeH agent={agent} lecs={lecs} />
        </Grid> 
        {/* ROW 3 */}
        <Grid size={6}>
          {orionVisible === null
            ? <OrionRatingGraphSkeleton />
            : orionVisible
              ? <OrionRatingGraph setVisibleGlobe={setVisibleGlobe} />
              : <RatingGraph setVisibleGlobe={setVisibleGlobe} data={ratingData} />}
        </Grid>
        <Grid size={6} sx={{ height: "100%" }}>
          <Highlights/>
        </Grid>
      </Grid>
    </Box>
  );
};

export default Dashboard;
